import React, { useState } from 'react';

type Props = {
  title: string;
  /** When true, section starts expanded. */
  defaultOpen?: boolean;
  children: React.ReactNode;
  /** Optional trailing controls (e.g. Add Port) rendered in the header. */
  actions?: React.ReactNode;
};

/** Collapsible section used by the Digital Twin Properties panel. */
const PropertySection: React.FC<Props> = ({
  title,
  defaultOpen = true,
  children,
  actions,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="rounded-lg border border-slate-200 bg-white px-2.5 py-2 dark:border-gray-700 dark:bg-gray-900/40">
      <div className="flex items-center justify-between gap-2">
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          className="flex min-w-0 items-center gap-1.5 text-[11px] font-semibold text-slate-600 hover:text-slate-900 dark:text-gray-300 dark:hover:text-gray-100"
        >
          <span
            className={`inline-block text-[9px] text-slate-400 transition-transform ${
              open ? 'rotate-90' : ''
            }`}
          >
            ▶
          </span>
          {title}
        </button>
        {actions}
      </div>
      {open && <div className="mt-2 space-y-1.5">{children}</div>}
    </div>
  );
};

export default PropertySection;
